import React from 'react';

export default class HorizontalLine extends React.Component {

    render() {
        return (
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
               <polyline
                   points="0,50 100,50"
                   stroke="lightgray"
                   strokeWidth="1"
                   fill="none" />
            </svg>
        )
    }

}
